import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import { GeneralIntroMainConfig, GeneralIntroPart1CCConfig, GeneralIntroPart1Config } from "../GeneralIntroMain";

export default class GeneralIntroPart1CC extends BaseScenarioPart<DaarcBaseScenario> {
	private currentSectionIndx = -1;
	private get config(): GeneralIntroPart1CCConfig {
		return this.scenarioConfig.part1Config;
	}
	constructor(private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralIntroMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.playNextSection();
	}

	public playNextSection() {
		const context = this;
		context.currentSectionIndx++;
		if(context.currentSectionIndx >= context.config.chapters.length) {
			context.step2Sbar();
			return;
		}
		var chapter = context.config.chapters[context.currentSectionIndx];
		context.playVideoChapter(chapter.chapterName(), () => {
			context.playNextSection()
		})
	}

	public step2Sbar() {
		const context = this;
		context.config.sbarConfig.onClosedClicked = () => {
			if(context.config.onSbarClosed) {
				context.config.onSbarClosed();
			}
			context.config.sbarConfig.onClosedClicked = () => {}; //remove callback so it does not try to do stuff with vortex anymore
			context.onDone();
		};
		context._scenario.uiWrapper.displaySBAR(context.config.sbarConfig);
	}
}